/*
     Title: Bundle API
     Description: Bundle API
     Author: Iqbal Hossain
     Date: 18-January-2022
     Modified: 18-January-2022
*/

export const BUNDLE_API = {
  root: '/api/bundle',
  fetch_all: 'api/bundle/fetch-all',
  fetch_by_query: `/api/bundle/fetch-by-query`,
  fetch_by_id: `/api/bundle/fetch-by-id`,
  get_by_range: `/api/bundle/get-range`
};
